import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser, fetchUserAttributes, signOut } from 'aws-amplify/auth';
import MainMenu from '../components/MainMenu';
import { useEntitlements } from '../contexts/EntitlementContext';

export default function MenuPage() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const { isPremium } = useEntitlements();

  useEffect(() => {
    let cancelled = false;
    Promise.all([getCurrentUser(), fetchUserAttributes().catch(() => ({}))])
      .then(([u, attrs]) => {
        if (cancelled) return;
        const displayName = attrs?.preferred_username || attrs?.name || attrs?.email?.split('@')[0];
        setUser({ ...u, displayName });
      })
      .catch(() => { /* guest */ });
    return () => { cancelled = true; };
  }, []);

  const handleSignOut = async () => {
    try { await signOut(); } catch { /* already signed out */ }
    setUser(null);
  };

  return (
    <>
      <MainMenu
        user={user}
        onStartClassic={() => navigate('/play/classic')}
        onStartDaily={() => navigate('/play/daily')}
        onShowLeaderboard={() => navigate('/leaderboard')}
        onShowProfile={() => navigate('/profile')}
        onSignOut={handleSignOut}
        onShowSubscription={() => navigate('/subscribe')}
        isPremium={isPremium}
      />
      {!user && (
        <div className="mt-6 text-center">
          <button
            type="button"
            onClick={() => navigate('/login')}
            className="text-sm text-primary-600 dark:text-primary-400 underline"
          >
            Sign in for leaderboards & daily challenges
          </button>
        </div>
      )}
    </>
  );
}
